import { render, staticRenderFns } from "./userlogs.vue?vue&type=template&id=316d1456&"
import script from "./userlogs.vue?vue&type=script&lang=js&"
export * from "./userlogs.vue?vue&type=script&lang=js&"
import style0 from "./userlogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports